export default "__VITE_ASSET__qn7UND67__"